export default __webpack_public_path__ + "static/media/pre-hire-appointment-completed.ba519d59.png";